module.exports = __webpack_public_path__ + "static/media/Oprationalmanagment.037b5922.svg";